import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

// Displays the uploading status and progress of the file upload
const LoadingBar = ({
  uploading,
  editingChildrenIds,
  verifying,
  id,
  disabled,
  localValue,
  formatBytes
}) => {
  const mainClassName = `loading-bar-inner ${
    uploading.isFile || editingChildrenIds[id]
      ? "loading-bar-inner-enable"
      : disabled || uploading.isSaved
      ? "loading-bar-inner-disable"
      : "loading-bar-inner-enable"
  }`;

  const status =
  uploading.uploading && !verifying
      ? "Uploading..."
      : verifying
      ? "Verifying..."
      : "Uploaded";

  const progress = (uploading.verifying || uploading.uploading) ? uploading.uploadProgress || 0 : 100;
  const totalSize = Number(formatBytes(localValue.size).split(" ")[0]);
  const unit = formatBytes(localValue.size).split(" ")[1];


  return (
    <div className="loading-bar-outer">
      <div
        className={mainClassName}
        style={{
          width: `${progress}%`,
        }}
      >
        {progress}%
        <span>{status}</span>
        <span>{" "}({Number((totalSize*(progress/100)).toFixed(2))} {unit} / {totalSize} {unit})</span>
      </div>
    </div>
  );
};

// shows the uploaded file related data
const RenderUploadFile = ({
  localValue,
  disabled,
  handleRemove,
  handleDownload,
  handleCancel,
  id,
}) => {
  const { editingChildrenIds, formatBytes, uploadingData } = useObjectInput();
  const statusClassName = `file-header-remove ${
    disabled ? "file-header-remove-disable" : "file-header-remove-enable"
  }`;

  const uploading = uploadingData[id] || {
    isFile: false,
    uploadProgress: 0,
    uploading: false,
    isSaved: false,
    verifying: false,
   }

  const verifying = uploading.verifying;

  return (
    <div>
      <div className="file-header-wrapper">
        <p className="file-header">
          {localValue.name}{" "}
          {localValue.size && (
            <span className="file-header-file-size">
              {formatBytes(localValue.size)}
            </span>
          )}
          <span
            className={statusClassName}
            onClick={
              uploading.uploading || verifying ? handleCancel : handleRemove
            }
          >
            {uploading.uploading || verifying ? "cancel" : "remove"}
          </span>
        </p>
        {!verifying && (
          <p className="file-header-download" onClick={handleDownload}>
            download
          </p>
        )}
      </div>
      <div>
        <LoadingBar
          uploading={uploading}
          editingChildrenIds={editingChildrenIds}
          verifying={verifying}
          id={id}
          disabled={disabled}
          localValue={localValue}
          formatBytes={formatBytes}
        />
      </div>
    </div>
  );
};

export default RenderUploadFile;
